/*
  Fait correspondre le visuel fixe au chapitre en cours de lecture.
  Le HTML est complet sans script : les chapitres et leurs images sont deja
  dans la page, on ne fait qu'enchainer les fondus sur grand ecran.
*/

class HeritageScroll extends HTMLElement {
  connectedCallback() {
    this.chapters = Array.from(this.querySelectorAll('[data-heritage-chapter]'));
    this.layers = Array.from(this.querySelectorAll('[data-heritage-layer]'));
    this.currentLabel = this.querySelector('[data-heritage-current]');
    this.bar = this.querySelector('[data-heritage-bar]');

    if (this.chapters.length < 2 || !('IntersectionObserver' in window)) return;

    this.desktop = window.matchMedia('(min-width: 990px)');
    this.onBreakpointChange = () => this.sync();

    if (this.desktop.addEventListener) {
      this.desktop.addEventListener('change', this.onBreakpointChange);
    } else {
      this.desktop.addListener(this.onBreakpointChange);
    }

    this.sync();
  }

  disconnectedCallback() {
    this.stop();

    if (!this.desktop) return;

    if (this.desktop.removeEventListener) {
      this.desktop.removeEventListener('change', this.onBreakpointChange);
    } else {
      this.desktop.removeListener(this.onBreakpointChange);
    }
  }

  /* Le suivi n'a de sens que la ou le visuel est fixe, c'est-a-dire sur grand ecran. */
  sync() {
    if (this.desktop.matches) {
      this.start();
    } else {
      this.stop();
    }
  }

  start() {
    if (this.observer) return;

    this.classList.add('heritage--interactive');

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.select(entry.target.dataset.heritageChapter);
        });
      },
      { rootMargin: '-45% 0px -45% 0px' }
    );

    this.chapters.forEach((chapter) => this.observer.observe(chapter));
    this.select(this.chapters[0].dataset.heritageChapter);
  }

  stop() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    this.classList.remove('heritage--interactive');
  }

  select(id) {
    if (!id || id === this.activeId) return;
    this.activeId = id;

    this.chapters.forEach((chapter) => {
      chapter.classList.toggle('is-current', chapter.dataset.heritageChapter === id);
    });

    this.layers.forEach((layer) => {
      const isCurrent = layer.dataset.heritageLayer === id;
      layer.classList.toggle('is-current', isCurrent);
      // Une seule image est visible : les autres sortent de l'arbre d'accessibilite.
      if (isCurrent) {
        layer.removeAttribute('aria-hidden');
      } else {
        layer.setAttribute('aria-hidden', 'true');
      }
    });

    const index = parseInt(id, 10);

    if (this.currentLabel) {
      this.currentLabel.textContent = index < 10 ? `0${index}` : String(index);
    }

    if (this.bar) {
      this.bar.style.width = `${(index / this.chapters.length) * 100}%`;
    }
  }
}

if (!customElements.get('heritage-scroll')) {
  customElements.define('heritage-scroll', HeritageScroll);
}
